import { SDK_DOCS } from "./sdkDocs";

export interface DocsSdkPageProps {
  slug: string;
}

export function DocsSdkPage({ slug }: DocsSdkPageProps) {
  const doc = SDK_DOCS.find((entry) => entry.slug === slug);
  if (!doc) {
    return null;
  }

  return (
    <div className="docs-article">
      <p className="docs-eyebrow">Clients</p>
      <h1 className="docs-page-title">{doc.label}</h1>
      <p className="docs-lede">{doc.summary}</p>
      <span
        className={`badge badge--accent${doc.badge.startsWith("Preview") ? " docs-page-status" : ""}`}
      >
        {doc.badge}
      </span>

      <h2 className="docs-heading">Supported managed surface</h2>
      <ul className="page-list">
        {doc.capabilities.map((item) => (
          <li key={item}>{item}</li>
        ))}
      </ul>

      <h2 className="docs-heading">Install the client</h2>
      <p className="docs-body">{doc.installation.description}</p>
      <div className="code-panel">
        <pre className="code-block">
          <code>{doc.installation.code}</code>
        </pre>
      </div>

      <h2 className="docs-heading">Host descriptor to client transport</h2>
      <ol className="docs-steps">
        {doc.descriptorSteps.map((step) => (
          <li key={step}>{step}</li>
        ))}
      </ol>

      <h2 className="docs-heading">Managed flow</h2>
      {doc.examples.map((example) => (
        <div key={example.title} className="docs-example">
          <p className="docs-example-title">{example.title}</p>
          <div className="code-panel">
            <pre className="code-block">
              <code>{example.code}</code>
            </pre>
          </div>
        </div>
      ))}

      <h2 className="docs-heading">Cancellation and bounds</h2>
      <ul className="page-list">
        {doc.bounds.map((item) => (
          <li key={item}>{item}</li>
        ))}
      </ul>

      <h2 className="docs-heading">Availability</h2>
      <p className="docs-body">{doc.availability}</p>
    </div>
  );
}
